export const environment = {
	production: true,
	vapidPublicKey: 'BKsNgIp0kZDOdfy4B9wIsl-iWSrBpp52QXNoMlVedvvtpDwturS3VmnH15ghzds1xuEpmaFrbOEbiEoJ9Z6WJ5w'
};
